import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import * as fromStore from '../store';
import * as featureActions from '../my-features/index';
import { UpdateInfoModel } from '../my-features/updateInfo/update-info.model';
import { updateInfoType } from '../shareModel';
import { TranslateService } from '@ngx-translate/core';
import { BlobServiceClient, ContainerClient } from '@azure/storage-blob';
import { CryptoService } from './crypto.service';
import { environment, azureBlobStorage } from '../../environments/environment';
import { AzureBlobStorageParam, ResponseInfo, PowerPanelServiceParam } from '../my-features/azure-blob-storage/azure-blob-storage.model';

@Injectable({
  providedIn: 'root'
})
export class AzureBlobStorageService {

  constructor(private store: Store<fromStore.State>, private http: HttpClient, private cryptoService: CryptoService,
    private translateService: TranslateService) { }

  ReadAzureBlobStorageFile(param: AzureBlobStorageParam) {
    const timeStamp = param.timestamp ? param.timestamp : new Date().getTime().toString().substr(0, 10);
    const blobName = param.path + '/' + timeStamp + '/' + param.name;

    const blobClient = this.containerClient(param.token, param.container).getBlobClient(blobName);
    return blobClient;
  }

  UploadAzureBlobStorageFile(param: AzureBlobStorageParam, handler: () => void) {
    const blobName = param.path + '/' + param.timestamp + '/' + param.name;
    const blockBlobClient = this.containerClient(param.token, param.container).getBlockBlobClient(blobName);
    const checkblobClient = this.containerClient('', param.container).getBlobClient(blobName);
    // blockBlobClient.uploadData(param.file, { blobHTTPHeaders: { blobContentType: param.file.type}}).then(res => {
    //   const ppsparam: PowerPanelServiceParam = {
    //     code: '',
    //     path: checkblobClient.url.replace(/\%2F/g, '/')
    //   };
    //   this.UploadPowerPanelServiceFile(ppsparam).pipe(first()).subscribe(resUpload => {
    //     const updateRes: UpdateInfoModel = {
    //       result: false,
    //       msg: '',
    //       errmsg: 'Error',
    //       type: updateInfoType.AddAzureBlobStorage
    //     };
    //     if (resUpload.Flag) {
    //       updateRes.result = true;
    //       updateRes.msg = this.translateService.instant('Update Success');
    //       this.store.dispatch(new featureActions.UpdateInfoSuccessAction(updateRes));
    //     } else {
    //       updateRes.errmsg = this.translateService.instant('Update Failed');
    //       this.store.dispatch(new featureActions.UpdateInfoFailAction(updateRes));
    //     }
    //   });
    // });

    return checkblobClient;
  }

  generateSharedAccessSignature(): Observable<string> {
    return this.http.post<string | { sasToken: string }>(`/api/azureblobstorage/generatesharedaccesssignature`, {}).pipe(
      map((res) => {
        if (typeof res === 'string') {
          return res;
        }
        return res && res.sasToken ? res.sasToken : '';
      })
    );
  }

  UploadPowerPanelServiceFile(params) {
    const body = {
      ...params,
      code: this.cryptoService.hashHmacSha512(new Date().getTime().toString().substr(0, 10)).toLowerCase()
    };
    return this.http.post<ResponseInfo>(`${environment.azureApiServiceUrl}/personal/api/Service/UploadFileByAzure`, body);
  }

  private containerClient(token, container): ContainerClient {
    const accountName = azureBlobStorage.accountName;

    if (token) {
      return new BlobServiceClient(`https://${accountName}.blob.core.windows.net?${token}`)
        .getContainerClient(container);
    } else {
      return new BlobServiceClient(`https://${accountName}.blob.core.windows.net`)
        .getContainerClient(container);
    }
  }
}
